module.exports = __webpack_public_path__ + "img/choli.9aa6960.webp";